import { useChainConfig } from "@/hooks/use-chain-config"

export interface Scanner {
  name: string
  url: string
  tokenUrl: string
  addressUrl: string
  makeTokenUrl: (tokenAddress: string) => string
  makeAddressUrl: (address: string) => string
}

const useScanner = (): Scanner => {
  const chainConfig = useChainConfig()

  try {
    const scanner: Scanner = {
      name: chainConfig.scanner.name,
      url: chainConfig.scanner.url,
      tokenUrl: chainConfig.scanner.tokenUrl,
      addressUrl: chainConfig.scanner.addressUrl,
      makeTokenUrl(tokenAddress) {
        return chainConfig.scanner.tokenUrl.replace("{tokenAddress}", tokenAddress)
      },
      makeAddressUrl(address) {
        return chainConfig.scanner.addressUrl.replace("{address}", address)
      },
    }
    return scanner
  } catch (error) {
    throw new Error("Scanner not configured", error as any)
  }
}

export default useScanner
